export default "__VITE_ASSET__CdSV0W_0__"